export default __webpack_public_path__ + "static/media/d-4.d2158225.jpg";